export * from './rfid-tags-widget'
